import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["align", "children", "color", "tag", "type", "variant", "className", "renderChildrenAsHTML"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import TypographyStyled, { variantsMap } from './Typography.styled';
import { jsx as _jsx } from "react/jsx-runtime";
var Typography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var align = _ref.align,
      children = _ref.children,
      color = _ref.color,
      tag = _ref.tag,
      type = _ref.type,
      variant = _ref.variant,
      className = _ref.className,
      renderChildrenAsHTML = _ref.renderChildrenAsHTML,
      rest = _objectWithoutProperties(_ref, _excluded);

  var TagComponent = tag;

  if (typeof variant !== 'string' && (!tag || !type)) {
    throw Error('For variant type object you have to pass the tag and type');
  }

  if (typeof variant === 'string' && !tag) {
    var _variantsMap$variant = variantsMap[variant],
        variantTag = _variantsMap$variant.tag,
        variantType = _variantsMap$variant.type;
    type = variantType;
    TagComponent = variantTag;
  }

  var getContent = function getContent() {
    if (!renderChildrenAsHTML) {
      return /*#__PURE__*/_jsx(TagComponent, {
        className: className,
        children: children
      });
    }

    if (typeof children !== 'string') {
      throw Error('You can only use `renderChildrenAsHTML` if the children is a `string`.');
    }

    return /*#__PURE__*/_jsx(TagComponent, {
      className: className,
      dangerouslySetInnerHTML: {
        __html: children
      }
    });
  };

  return /*#__PURE__*/_jsx(TypographyStyled, _objectSpread(_objectSpread({
    align: align,
    variant: variant,
    type: type,
    tone: color,
    asChild: true,
    ref: ref
  }, rest), {}, {
    children: getContent()
  }));
});
Typography.displayName = 'Typography';

Typography.toString = function () {
  return TypographyStyled.selector;
};

export default Typography;